// extracted by mini-css-extract-plugin
export default {"skeleton":"Brand_skeleton__wTO3V","shimmer":"Brand_shimmer__uShVx"};